'use client';
import React from 'react';
import { CalendarDays } from 'lucide-react';

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Week of 4–10 May 2026
const calendarData = [
  { id: 'cal-mon', day: 'Mon', date: 5, events: [{ id: 'ev-001', label: 'Full day care', color: 'var(--primary)', confirmed: true }] },
  { id: 'cal-tue', day: 'Tue', date: 6, events: [{ id: 'ev-002', label: 'Requested', color: '#4F46E5', confirmed: false }] },
  { id: 'cal-wed', day: 'Wed', date: 7, events: [{ id: 'ev-003', label: 'Companionship', color: 'var(--success)', confirmed: true }] },
  { id: 'cal-thu', day: 'Thu', date: 8, events: [] },
  { id: 'cal-fri', day: 'Fri', date: 9, events: [] },
  { id: 'cal-sat', day: 'Sat', date: 10, events: [{ id: 'ev-004', label: 'Overnight care', color: 'var(--primary)', confirmed: false }] },
  { id: 'cal-sun', day: 'Sun', date: 11, events: [] },
];

const today = 3; // May 3

export default function WorkerCalendarSnapshot() {
  return (
    <div className="card overflow-hidden h-full">
      <div className="px-5 pt-5 pb-4 border-b border-border flex items-center justify-between">
        <h3 className="font-bold" style={{ color: 'var(--navy)' }}>This week</h3>
        <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>4–10 May 2026</span>
      </div>
      <div className="p-4 space-y-2">
        {calendarData?.map((day) => (
          <div
            key={day?.id}
            className="flex items-start gap-3 p-3 rounded-xl transition-colors hover:bg-muted/40"
            style={{ background: day?.date === today ? 'var(--orange-pale)' : 'transparent' }}
          >
            <div className="flex-shrink-0 text-center w-9">
              <div className="text-xs font-semibold" style={{ color: 'var(--muted-foreground)' }}>{day?.day}</div>
              <div
                className="text-sm font-extrabold w-8 h-8 rounded-full flex items-center justify-center mx-auto mt-0.5 tabular-nums"
                style={{
                  background: day?.date === today ? 'var(--primary)' : 'transparent',
                  color: day?.date === today ? 'white' : 'var(--navy)',
                }}
              >
                {day?.date}
              </div>
            </div>

            <div className="flex-1 min-w-0 pt-0.5">
              {day?.events?.length === 0 ? (
                <span className="text-xs" style={{ color: 'var(--border)' }}>No bookings</span>
              ) : (
                day?.events?.map((ev) => (
                  <div key={ev?.id} className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: ev?.color }} />
                    <span className="text-xs font-medium truncate" style={{ color: 'var(--foreground)' }}>{ev?.label}</span>
                    {!ev?.confirmed && (
                      <span className="text-xs px-1.5 py-0.5 rounded-full font-semibold flex-shrink-0" style={{ background: '#EEF2FF', color: '#4F46E5' }}>
                        Pending
                      </span>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="px-5 pb-5">
        <button className="w-full py-2.5 rounded-xl text-sm font-semibold border border-border hover:bg-muted transition-colors flex items-center justify-center gap-2" style={{ color: 'var(--navy)' }}>
          <CalendarDays size={16} />
          Manage full calendar
        </button>
      </div>
    </div>
  );
}